import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";

const LABELS = {
  "home": "Home",
  "chi-siamo": "Chi Siamo",
  "storia-e-valori": "Storia e Valori",
  "organismi": "Organismi",
  "statuto-e-regolamenti": "Statuto e Regolamenti",
  "enti-collegati": "Società di Servizi",
  "promo-ter": "Promo.Ter",
  "cat": "C.A.T. Confcommercio Roma",
  "partner": "Partner",
  "il-nostro-impegno": "Il Nostro Impegno",
  "trasparenza": "Trasparenza",
  "struttura-tecnica": "Struttura Tecnica",
  "servizi": "Servizi",
  "rappresentanza": "La Rappresentanza",
  "consulenza-lavoro-welfare": "Consulenza sul lavoro e welfare",
  "sicurezza-lavoro": "Sicurezza sul lavoro",
  "formazione-professionale": "Formazione professionale",
  "sportello-spin-edi": "Sportello SPIN EDI",
  "formazione-finanziata": "Formazione Finanziata",
  "apprendistato": "Contratto di Apprendistato",
  "aggiornamento-specializzazione": "Aggiornamento e Specializzazione",
  "formazione-abilitante": "Formazione Abilitante e Progetti Speciali",
  "formazione-a-distanza": "Formazione a Distanza (FAD)",
  "area-lavoro-welfare": "Area Lavoro e Welfare",
  "contrattazione-collettiva": "Contrattazione Collettiva",
  "flessibilita-organizzativa": "Flessibilità Organizzativa",
  "welfare-aziendale": "Welfare Aziendale",
  "assunzioni-agevolate": "Assunzioni Agevolate",
  "contenzioso-lavoro": "Contenzioso sul Lavoro",
  "parita-genere": "Parità di Genere",
  "notizie": "Notizie",
  "eventi": "Appuntamenti",
  "le-bussole": "Le Bussole",
  "osservatorio-economico": "Osservatorio Economico",
  "associazioni": "Associazioni",
  "progetti": "Progetti",
  "convenzioni": "Convenzioni",
  "contatti": "Contatti",
  "formazione": "Formazione",
};

function getLabel(seg) {
  return LABELS[seg] || seg.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function HeroBreadcrumb() {
  const { pathname } = useLocation();
  const segments = pathname.replace(/^\/|\/$/g, "").split("/").filter(Boolean);

  if (segments.length === 0) return null;

  // Tutti gli antenati (esclusa la pagina corrente) — senza Home
  const crumbs = segments.slice(0, -1).map((seg, idx) => ({
    label: getLabel(seg),
    path: "/" + segments.slice(0, idx + 1).join("/"),
  }));

  // Nessun antenato da mostrare (pagina di primo livello)
  if (crumbs.length === 0) return null;

  // Il genitore diretto è l'ultimo crumb (destinazione della freccia)
  const parentPath = crumbs[crumbs.length - 1].path;

  return (
    <nav aria-label="Breadcrumb" data-testid="hero-breadcrumb" className="mb-3">
      <ol className="flex items-center flex-wrap gap-x-1.5 gap-y-1 text-sm text-white/70">
        {/* Freccia indietro verso il genitore */}
        <li>
          <Link
            to={parentPath}
            className="flex items-center hover:text-white transition-colors"
            aria-label="Torna indietro"
          >
            <ArrowLeft size={15} aria-hidden="true" />
          </Link>
        </li>

        {crumbs.map((crumb, idx) => {
          const isLast = idx === crumbs.length - 1;
          return (
            <li key={crumb.path} className="flex items-center gap-x-1.5">
              {idx > 0 && (
                <ChevronRight size={12} className="text-white/30 shrink-0" aria-hidden="true" />
              )}
              <Link
                to={crumb.path}
                className={`hover:text-white transition-colors whitespace-nowrap ${
                  isLast ? "text-white/90" : "text-white/60"
                }`}
              >
                {crumb.label}
              </Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
